(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afterlight-photo-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('afterlight-photo-comparison')) {
  customElements.define('afterlight-photo-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const slider = this.querySelector('input[type="range"]');
      if (!slider) return;
      const update = () => this.style.setProperty('--reveal', `${slider.value}%`);
      slider.addEventListener('input', update, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afterlight-short-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('afterlight-random-reviews')) {
  customElements.define('afterlight-random-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.shuffled || window.Shopify?.designMode) return;
      const grid = this.querySelector('.al-reviews__grid');
      if (!grid) return;
      const cards = Array.from(grid.children);
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      const fragment = document.createDocumentFragment();
      cards.forEach((card, index) => {
        card.hidden = index >= 4;
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);
      this.dataset.shuffled = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initializeHomeHeaderIntro = (container) => {
    const header = container.querySelector('.header-wrapper--home-intro');
    if (!header || header.dataset.introInitialized === 'true') return;

    header.dataset.introInitialized = 'true';
    let started = false;

    const start = () => {
      if (started) return;
      started = true;

      requestAnimationFrame(() => {
        header.classList.add('is-running');
        document.body.classList.add('afterlight-home-hero-running');

        const icons = header.querySelector('.header__icons');
        icons?.addEventListener('animationend', (event) => {
          if (event.target === icons && event.animationName === 'afterlight-header-item-arrive') {
            header.classList.add('is-done');
          }
        }, { once: true });

        window.setTimeout(() => header.classList.add('is-done'), 2500);
      });
    };

    if (document.readyState !== 'loading') {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    }
  };

  initializeHomeHeaderIntro(document);
  document.addEventListener('shopify:section:load', (event) => initializeHomeHeaderIntro(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.reviewsMotionReady === 'true') return;

      const wrapper = root.querySelector('.reviews-wrapper');
      const track = root.querySelector('.reviews-track');
      const animation = track?.getAnimations().find((item) => item.animationName === 'scroll-left');

      if (!wrapper || !animation) return;
      root.dataset.reviewsMotionReady = 'true';

      let frameId;

      const easeTo = (target) => {
        cancelAnimationFrame(frameId);
        const initialRate = animation.playbackRate;
        const start = performance.now();
        const duration = 650;

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          animation.playbackRate = initialRate + (target - initialRate) * eased;

          if (progress < 1) frameId = requestAnimationFrame(step);
        };

        frameId = requestAnimationFrame(step);
      };

      wrapper.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') easeTo(0);
      });
      wrapper.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') easeTo(1);
      });
      wrapper.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') easeTo(0);
      });
      wrapper.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'touch') easeTo(1);
      });
      wrapper.addEventListener('pointercancel', (event) => {
        if (event.pointerType === 'touch') easeTo(1);
      });
    };

    const initializeAll = (container) => {
      container.querySelectorAll('[data-scrolling-reviews]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
